import axios from 'axios';
import { useState, useEffect } from "react";

// API-URL für die SPS-Supply-Daten
const SPS_SUPPLY_API = "https://splinterlands-validator-api.splinterlands.com/extensions/tokens/SPS/supply";

// Die neue Version speichert keine Historie und keinen LocalStorage mehr.
// Sie bietet nur noch aktuelle Burned-Amount-Daten (für Counter etc.).

let listeners = [];
let isInitialized = false;
let lastUpdate = null;
let currentBurnedAmount = 0;

// Aktuellen Burned-Amount von der API abrufen
const fetchCurrentBurnedAmount = async () => {
  try {
    const response = await axios.get(SPS_SUPPLY_API);
    if (response.data && response.data.burned) {
      currentBurnedAmount = parseFloat(response.data.burned);
      lastUpdate = new Date();
      notifyListeners();
    }
  } catch (error) {
  }
};

// Listener über Änderungen informieren
const notifyListeners = () => {
  const data = {
    currentBurnedAmount,
    lastUpdate
  };
  listeners.forEach(callback => {
    try {
      callback(data);
    } catch (error) {
    }
  });
};

// Service initialisieren
const initialize = async () => {
  if (isInitialized) return;
  await fetchCurrentBurnedAmount();
  isInitialized = true;
};

const BurnTrackerService = {
  // Service initialisieren
  init: () => {
    initialize();
  },
  // Manuell aktuelle Daten abrufen
  refreshData: async () => {
    await fetchCurrentBurnedAmount();
  },
  // Aktuelle Burn-Menge abrufen
  getCurrentBurnedAmount: () => {
    return currentBurnedAmount;
  },
  // Abonnieren von Datenänderungen
  subscribe: (callback) => {
    listeners.push(callback);
    // Sofort mit aktuellen Daten aufrufen
    callback({
      currentBurnedAmount,
      lastUpdate
    });
    // Unsubscribe-Funktion zurückgeben
    return () => {
      listeners = listeners.filter(listener => listener !== callback);
    };
  },
  // Zeitpunkt der letzten Aktualisierung
  getLastUpdate: () => {
    return lastUpdate;
  }
};

export default BurnTrackerService;

// Changed from default export to named export
export const useFetchBurnData = (url) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(url);

        if (response.headers['content-type'].includes('application/json')) {
          setData(response.data);
          setError(null);
        } else {
          throw new Error("Invalid JSON response");
        }
      } catch (err) {
        console.error("Error fetching burn data:", err);
        setError("Error loading burn data: " + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url]);

  return { data, error, loading };
};